import { Card, CardBody, Col } from "reactstrap";
import { NestingTitle } from "../../../../constants";
import NestingButtonDropdown from "./NestingButtonDropdown";
import NestingButtonIcons from "./NestingButtonIcons";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";
import { NestingButtonSpan } from "../../../../data/buttons/GroupButton";

const NestingButton = () => {
  return (
    <Col lg="6">
      <Card>
        <CommonCardHeader headClass="card-no-border pb-0" title={NestingTitle} span={NestingButtonSpan} tag />
        <CardBody className="btn-group-wrapper">
          <NestingButtonDropdown />
          <NestingButtonIcons />
        </CardBody>
      </Card>
    </Col>
  );
};

export default NestingButton;
